export default {
  saveAsWord: {
    id: 'profileActions.saveAsWord',
    defaultMessage: 'Save as Microsoft Word',
  },
  uploadFile: {
    id: 'profileActions.uploadFile',
    defaultMessage: 'Attach file',
  },
  uploadErrMsg: {
    id: 'profileActions.uploadErrMsg',
    defaultMessage: 'Upload failed. Try again later.',
  },
  uploadErrMsgSize: {
    id: 'profileActions.uploadErrMsgSize',
    defaultMessage: 'File size is more than 10MB. Select a smaller one.',
  },
  uploadErrMsgType: {
    id: 'profileActions.uploadErrMsgType',
    defaultMessage: 'Acceptable file types: PDF, DOC, DOCX, RTF, TXT',
  },
  enrichQuestion: {
    id: 'profileActions.enrichQuestion',
    defaultMessage: 'Do you want to update profile from {filename}?',
  },
  confirmEnrich: {
    id: 'profileActions.confirmEnrich',
    defaultMessage: 'Yes',
  },
  cancelEnrich: {
    id: 'profileActions.cancelEnrich',
    defaultMessage: 'No',
  },
  saveAsPDF: {
    id: 'profileActions.saveAsPDF',
    defaultMessage: 'Save as PDF',
  },
  generalInfo: {
    id: 'profileActions.generalInfo',
    defaultMessage: 'General info',
  },
  relevantSkills: {
    id: 'profileActions.relevantSkills',
    defaultMessage: 'Relevant Skills',
  },
  coursesAndCertificates: {
    id: 'profileActions.coursesAndCertificates',
    defaultMessage: 'Courses and Certificates',
  },
  languages: {
    id: 'profileActions.languages',
    defaultMessage: 'Languages',
  },
  contacts: {
    id: 'profileActions.contacts',
    defaultMessage: 'Contacts',
  },
  workExperience: {
    id: 'profileActions.workExperience',
    defaultMessage: 'Work experience',
  },
  schools: {
    id: 'profileActions.schools',
    defaultMessage: 'Schools',
  },
  banProfile: {
    id: 'profileActions.banProfile',
    defaultMessage: 'Ban profile',
  },
  report: {
    id: 'profileActions.report',
    defaultMessage: 'Report a problem',
  },
  downloadError: {
    id: 'profileActions.downloadError',
    defaultMessage: 'Failed to download the file. Please try again later.',
  },
};
